import Listbox from "./Listbox-2.jsx";
import React from "react";

export default ({ assets = [], resultsBehavior = {} }) => {
    
    return (
        <header className="tw-flex tw-items-center tw-justify-between tw-mb-4 lg:tw-mb-1">
            <div className="tw-font-sans tw-font-light tw-text-[14px]">
                1 - {assets.items.length} of {assets.total} Results
            </div>
            <div>
                <Listbox
                    label={resultsBehavior.Label}
                    selectList={resultsBehavior.OrderByTypes}
                    selected={resultsBehavior.OrderBy}
                    setSelected={resultsBehavior.SetOrderBy}
                />
            </div>
        </header>
    );
}

